import { render, staticRenderFns } from "./modal-examlink.vue?vue&type=template&id=9cbb5d54&scoped=true"
import script from "./modal-examlink.vue?vue&type=script&lang=ts"
export * from "./modal-examlink.vue?vue&type=script&lang=ts"
import style0 from "./modal-examlink.vue?vue&type=style&index=0&id=9cbb5d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbb5d54",
  null
  
)

export default component.exports